import { HttpRequest } from '@angular/common/http';

// Modify url due to request body / params / header unique values and match it with proper JSON
export function modifyRequestUrlForDemoMode(request: HttpRequest<any>): HttpRequest<any> {
  if (request.url.match(/dc-diagstack-\d+\/diagnostic-generic-otx\/execute/)) {
    const url = request.url + '_' + request.body.otxParameters.listOfDTC[0];
    // Expected values from mocks:
    // "InterruptionFourThreeWayValve"
    // "FailureCommunicationWiredRemoteControl"

    return request.clone({ url });
  }

  return request;
}
